import { render, staticRenderFns } from "./BucketGrid.vue?vue&type=template&id=5546257e&"
import script from "./BucketGrid.vue?vue&type=script&lang=js&"
export * from "./BucketGrid.vue?vue&type=script&lang=js&"
import style0 from "./BucketGrid.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports